import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FinancialSetupModel
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/model-template/financial-setup.model";
import { ModalService } from "@components/modal/modal.service";
import { StandardQuoteService } from "@app/pages/quote/standard-quote/standard-quote-service.service";
import { NotificationService } from "@app/services/notifications.service";
import {
  FinancialProductService
} from "@app/pages/quote/standard-quote/catalogs/financial-product/financial-product.service";
import { EntitiesServices } from "@app/services/entities.service";
import { AppCommonModule } from "@components/app.common.module";
import { NgIf } from "@angular/common";
import { DealerTemplateService } from './dealer-template.services';
import { queryParmsDealer } from '../../../model.models';
export class DealerModel {
  enabled: boolean;
  idBranch: number;
  dealerName: string;
  groupName: any;
  branchName: string;
  isChecked: boolean;
}

@Component({
  selector: 'app-dealer-template',
  standalone: true,
  imports: [
    AppCommonModule,
    NgIf
  ],
  templateUrl: './dealer-template.component.html',
  styleUrl: './dealer-template.component.css'
})
export class DealerTemplateComponent implements OnInit {
  isLoading: boolean = false;
  @Input() dealerIds: number[] = [];
  @Output() dealerSelectedEmit = new EventEmitter<number[]>();
  public dealersList: DealerModel[] = [];
  public allDealers: DealerModel[] = [];
  public showOnlySelected: boolean = false;
  public groups: { value: string; label: string }[] = [];
  public reset: boolean = false;
  public selectedGroup: string | null = null;
  public selectedBranch: string | null = null;
  branches: { value: string; label: string }[] = [];
  searchName: any = { placeholder: 'Buscar por nombre', value: '' };

  params : queryParmsDealer = {
    dealerName :  null,
    groupName :  null,
    enabled :  null,
    branchName : null
}

  constructor(private modalService: ModalService,
    private entitiesServices: EntitiesServices,
    private notificationsService: NotificationService,
    private dealerTemplateService: DealerTemplateService
  ) { }

  ngOnInit(): void {
    this.showOnlySelected = this.dealerIds.length > 0;
    this.loadDealers();
    this.loadGroups();

  }

  private loadDealers(): void {
    this.isLoading = true;
    this.dealerTemplateService.getDealers(this.params).subscribe({
      next: (response) => {
        this.dealersList = response.data
          .filter((dealer: DealerModel) => dealer.enabled === true && dealer.idBranch !== null);
        this.dealersList.sort((a: DealerModel, b: DealerModel) => {
          if (a.dealerName && b.dealerName) {
            return a.dealerName.localeCompare(b.dealerName);
          }
          return 0;
        });
  
        this.dealersList.forEach((dealer: DealerModel) => {
          dealer.isChecked = this.dealerIds.includes(dealer.idBranch);
        });
        if (this.showOnlySelected) {
          this.dealersList = this.dealersList.filter(dealer => dealer.isChecked);
        }
        this.allDealers = [...this.dealersList];
        this.branches = Array.from(new Set(this.dealersList
          .map(dealer => dealer.branchName)
          .filter(branchName => branchName !== null) 
        ))
        .sort((a, b) => a.localeCompare(b)) 
        .map(branchName => ({ value: branchName, label: branchName }));
        this.isLoading = false;
        this.search();
      },
      error: (_error) => {
        this.search();
        this.isLoading = false;
        this.notificationsService.showMessage(
          ['Ha ocurrido un error. Vuelva a intentarlo.'],
          'error'
        );
      }
    });
  }
  
  close() {
    this.modalService.closeModal();
  }

  closeAndSave() {
    this.dealerSelectedEmit.emit(this.dealerIds);
    this.close();
  }

  public addDealer(event: any, dealer: DealerModel): void {
    dealer.isChecked = event.target.checked;
  
    if (this.selectedBranch && dealer.branchName === this.selectedBranch) {
      this.dealerIds = dealer.isChecked
        ? [...this.dealerIds, dealer.idBranch]
        : this.dealerIds.filter(id => id !== dealer.idBranch);
    } else if (!this.selectedBranch) {
      this.dealerIds = dealer.isChecked
        ? [...this.dealerIds, dealer.idBranch]
        : this.dealerIds.filter(id => id !== dealer.idBranch);
    }
  }

  public checkAllDealers(event: any) {
    this.dealersList.forEach((dealer) => {
      dealer.isChecked = true;
    });
    this.dealerIds = this.dealersList.map((dealer) => dealer.idBranch);
  }

  public uncheckAllDealers(event: any) {
    this.dealersList.forEach((dealer) => {
      dealer.isChecked = false;
    });
    this.dealerIds = [];
  }

  showAmount(model: any) {
    return model?.length ?? 0;
  }

  public toggleOnlySelectedDealers(event: any) {
    this.showOnlySelected = event.target.checked;
    if (this.showOnlySelected) {
      this.dealersList = this.dealersList.filter(dealer => dealer.isChecked);
    } else {
      this.loadDealers();
    }
  }
  
  private loadGroups(): void {
    this.dealerTemplateService.getGroups().subscribe({
      next: (response: any) => {
        this.groups = response.data.map((group: any) => ({
          value: group.name,
          label: group.name
        }));
      },
      error: (err) => {
        console.error('Error cargando grupos desde la API', err);
      }
    });
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'name':
        this.searchName.value = value;
        break;
      case 'groupName':
        this.selectedGroup = value;
        break;
      case 'branchName':
        this.selectedBranch = value;
        break;
    }
    this.search();
  }

  search() {
    this.dealersList = this.allDealers.filter(dealer => {
      const matchesName = this.searchName.value
        ? dealer.dealerName.toLowerCase().includes(this.searchName.value.toLowerCase())
        : true;
  
      const matchesBranch = this.selectedBranch
        ? dealer.branchName && dealer.branchName.toLowerCase() === this.selectedBranch.toLowerCase()
        : true;
  
      const matchesGroup = this.selectedGroup
        ? dealer.groupName && dealer.groupName.toLowerCase() === this.selectedGroup.toLowerCase()
        : true;
  
      return matchesName && matchesBranch && matchesGroup;
    });
  }

  resetFilters() {
    this.searchName = { placeholder: 'Buscar por nombre', value: '' }; 
    this.selectedGroup = null;
    this.selectedBranch = null;
    this.reset = !this.reset;
    this.dealersList = [...this.allDealers];
    this.search();
  }
}